import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText
} from '@material-ui/core';

const CreateDialog = ({open, body, label, handleClose, handleSave, ...props}) => {

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-create-dialog-title" fullWidth>
            <DialogTitle id="form-create-dialog-title" disableTypography>
                <h4 className={"dialog-title"}>Create {label}</h4>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {body}
                </DialogContentText>

                {props.children}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default CreateDialog;